import { render, staticRenderFns } from "./CoreProgramCampaignSettings.vue?vue&type=template&id=3ca11c9e&scoped=true&"
import script from "./CoreProgramCampaignSettings.vue?vue&type=script&lang=js&"
export * from "./CoreProgramCampaignSettings.vue?vue&type=script&lang=js&"
import style0 from "./CoreProgramCampaignSettings.vue?vue&type=style&index=0&id=3ca11c9e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca11c9e",
  null
  
)

export default component.exports